export const uploadToCloudinary = async (file) => {
    const url = 'https://api.cloudinary.com/v1_1/dsoj8lhed/upload';
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', 'plany365_upload');

    const response = await fetch(url, {
        method: 'POST',
        body: formData,
    });

    const data = await response.json();
    if (!response.ok) {
        throw new Error(data?.error?.message || 'Photo upload failed. Please try again.');
    }
    if (!data.secure_url) {
        throw new Error('The upload service did not return a photo URL. Please try again.');
    }
    return data.secure_url;
};
